(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightone-shop-page-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-lto-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.ltoReady === 'true') return;
      root.dataset.ltoReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantData = root.querySelector('[data-lto-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-lto-variant-id]');
      const priceEl = root.querySelector('[data-lto-price]');
      const compareEl = root.querySelector('[data-lto-compare]');
      const saveEl = root.querySelector('[data-lto-save]');
      const atcText = root.querySelector('[data-lto-atc-text]');
      const submitButton = root.querySelector('.lto-atc');
      const optionGroups = Array.from(root.querySelectorAll('[data-lto-option]'));
      const choices = Array.from(root.querySelectorAll('[data-lto-option-choice]'));

      const getState = () =>
        optionGroups.map((group) => {
          const selected = group.querySelector('[data-lto-option-choice].is-selected');
          const first = group.querySelector('[data-lto-option-choice]');
          return selected ? selected.dataset.ltoOptionValue : first ? first.dataset.ltoOptionValue : '';
        });

      const findVariant = (state) =>
        variants.find((variant) => variant.options.every((option, index) => option === state[index]));

      const hasVariantForChoice = (index, value, state) =>
        variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((option, optionIndex) => {
            if (optionIndex === index) return option === value;
            return option === state[optionIndex];
          });
        });

      const updateChoiceAvailability = (state) => {
        choices.forEach((choice) => {
          const index = Number(choice.dataset.ltoOptionIndex || 0);
          const value = choice.dataset.ltoOptionValue || '';
          const possible = hasVariantForChoice(index, value, state);
          choice.classList.toggle('is-unavailable', !possible);
          choice.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      };

      const setVariant = () => {
        let state = getState();
        let variant = findVariant(state);

        if (!variant) {
          const fallback = variants.find((candidate) => candidate.available) || variants[0];
          if (fallback) {
            state = fallback.options;
            optionGroups.forEach((group, groupIndex) => {
              group.querySelectorAll('[data-lto-option-choice]').forEach((choice) => {
                const selected = choice.dataset.ltoOptionValue === state[groupIndex];
                choice.classList.toggle('is-selected', selected);
                choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
              });
            });
            variant = fallback;
          }
        }

        updateChoiceAvailability(state);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }
        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }
        if (atcText) atcText.textContent = variant.available ? 'Add LightOne to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);
      };

      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          if (choice.classList.contains('is-unavailable')) return;
          const group = choice.closest('[data-lto-option]');
          if (!group) return;
          group.querySelectorAll('[data-lto-option-choice]').forEach((sibling) => {
            const selected = sibling === choice;
            sibling.classList.toggle('is-selected', selected);
            sibling.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          setVariant();
        });
      });

      setVariant();

      const revealTargets = Array.from(root.querySelectorAll('.lto-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.14, rootMargin: '-4% 0px -8% 0px' }
        );
        revealTargets.forEach((target) => observer.observe(target));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightone-shop-page-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-lto-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.ltoReady === 'true') return;
      root.dataset.ltoReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantData = root.querySelector('[data-lto-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-lto-variant-id]');
      const priceEl = root.querySelector('[data-lto-price]');
      const compareEl = root.querySelector('[data-lto-compare]');
      const saveEl = root.querySelector('[data-lto-save]');
      const payLaterMessage = root.querySelector('[data-paypal-pay-later-message]');
      const atcText = root.querySelector('[data-lto-atc-text]');
      const submitButton = root.querySelector('.lto-atc');
      const optionGroups = Array.from(root.querySelectorAll('[data-lto-option]'));
      const choices = Array.from(root.querySelectorAll('[data-lto-option-choice]'));

      const getState = () =>
        optionGroups.map((group) => {
          const selected = group.querySelector('[data-lto-option-choice].is-selected');
          const first = group.querySelector('[data-lto-option-choice]');
          return selected ? selected.dataset.ltoOptionValue : first ? first.dataset.ltoOptionValue : '';
        });

      const findVariant = (state) =>
        variants.find((variant) => variant.options.every((option, index) => option === state[index]));

      const hasVariantForChoice = (index, value, state) =>
        variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((option, optionIndex) => {
            if (optionIndex === index) return option === value;
            return option === state[optionIndex];
          });
        });

      const updateChoiceAvailability = (state) => {
        choices.forEach((choice) => {
          const index = Number(choice.dataset.ltoOptionIndex || 0);
          const value = choice.dataset.ltoOptionValue || '';
          const possible = hasVariantForChoice(index, value, state);
          choice.classList.toggle('is-unavailable', !possible);
          choice.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      };

      const setVariant = () => {
        let state = getState();
        let variant = findVariant(state);

        if (!variant) {
          const fallback = variants.find((candidate) => candidate.available) || variants[0];
          if (fallback) {
            state = fallback.options;
            optionGroups.forEach((group, groupIndex) => {
              group.querySelectorAll('[data-lto-option-choice]').forEach((choice) => {
                const selected = choice.dataset.ltoOptionValue === state[groupIndex];
                choice.classList.toggle('is-selected', selected);
                choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
              });
            });
            variant = fallback;
          }
        }

        updateChoiceAvailability(state);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (payLaterMessage && variant.price_amount) {
          payLaterMessage.setAttribute('data-pp-amount', variant.price_amount);
        }
        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }
        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }
        if (atcText) atcText.textContent = variant.available ? 'Add LightOne to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);
      };

      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          if (choice.classList.contains('is-unavailable')) return;
          const group = choice.closest('[data-lto-option]');
          if (!group) return;
          group.querySelectorAll('[data-lto-option-choice]').forEach((sibling) => {
            const selected = sibling === choice;
            sibling.classList.toggle('is-selected', selected);
            sibling.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          setVariant();
        });
      });

      setVariant();

      const revealTargets = Array.from(root.querySelectorAll('.lto-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.14, rootMargin: '-4% 0px -8% 0px' }
        );
        revealTargets.forEach((target) => observer.observe(target));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-cro-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('[data-qd-cro]').forEach((root) => {
        if (root.dataset.qdCroReady === 'true') return;
        root.dataset.qdCroReady = 'true';

        root.querySelectorAll('[data-qd-buy-link]').forEach((link) => {
          link.addEventListener('click', (event) => {
            const target = document.querySelector('product-info[id^="MainProduct"], .product__info-container, form[action*="/cart/add"]');
            if (!target) return;

            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-explorer-page-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const smooth = (value) => value * value * (3 - 2 * value);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const scenes = [
      {
        id: 'hero-start',
        from: 0,
        to: 0.08,
        startFrame: 1,
        endFrame: 31,
        eyebrow: 'QuadDrive Explorer',
        title: 'Build the drive your work actually needs.',
        body: 'A 4-bay USB4 NVMe enclosure for creators, engineers, and mobile workstations that outgrow sealed external SSDs.',
        metric: '4-Bay USB4',
        metricNote: 'QuadDrive enclosure plus 65W USB-C PD adapter. SSDs sold separately.',
        backword: 'QUADDRIVE',
        ghostword: 'USB4'
      },
      {
        id: 'four-nvme',
        from: 0.08,
        to: 0.5,
        startFrame: 32,
        endFrame: 103,
        easing: 'fast-insert',
        eyebrow: 'Install and scale',
        title: 'Start with one NVMe. Scale to four.',
        body: 'Install 2230, 2242, or 2280 M.2 NVMe SSDs and grow toward 32TB total without replacing the enclosure.',
        metric: '1-4 M.2 NVMe',
        metricNote: 'JBOD or OS-managed software RAID workflows.',
        backword: '4 NVME',
        ghostword: '32TB'
      },
      {
        id: 'io-transition',
        marker: 'thunderbolt',
        from: 0.5,
        to: 0.64,
        startFrame: 104,
        endFrame: 127,
        easing: 'approach-hold',
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'The camera moves from the four-bay build to the I/O edge before the speed story lands.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'thunderbolt',
        from: 0.64,
        to: 0.8,
        startFrame: 127,
        endFrame: 127,
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'One USB-C link carries USB4 and Thunderbolt-class data. A separate USB-C PD input feeds stable power to the four-drive system while data moves fast.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'hero-return',
        from: 0.8,
        to: 1,
        startFrame: 128,
        endFrame: 151,
        eyebrow: 'Ready for work',
        title: 'One compact box. A storage plan that keeps growing.',
        body: 'For project media, scratch disks, backup staging, and lab work that needs fast removable NVMe storage without cable clutter.',
        metric: 'Build yours',
        metricNote: 'Order the enclosure, then choose the SSD capacity that fits your workflow.',
        backword: 'READY',
        ghostword: 'SSD'
      }
    ];

    const preloadFrame = (cache, urls, frame) => {
      const index = clamp(frame - 1, 0, urls.length - 1);
      if (cache.has(index)) return cache.get(index);

      const image = new Image();
      image.decoding = 'async';
      image.src = urls[index];
      cache.set(index, image);
      return image;
    };

    const initScroll = (section) => {
      if (section.dataset.qdxReady === 'true') return;
      section.dataset.qdxReady = 'true';

      const frameData = section.querySelector('[data-qdx-frames]');
      const imageEl = section.querySelector('[data-qdx-frame-image]');
      const titleEl = section.querySelector('[data-qdx-title]');
      const bodyEl = section.querySelector('[data-qdx-body]');
      const eyebrowEl = section.querySelector('[data-qdx-eyebrow]');
      const metricEl = section.querySelector('[data-qdx-metric]');
      const metricNoteEl = section.querySelector('[data-qdx-metric-note]');
      const backwordEl = section.querySelector('[data-qdx-backword]');
      const ghostwordEl = section.querySelector('[data-qdx-ghostword]');
      const progressEl = section.querySelector('[data-qdx-progress]');
      const markers = Array.from(section.querySelectorAll('[data-qdx-marker]'));

      if (!frameData || !imageEl) return;

      let urls = [];
      try {
        urls = JSON.parse(frameData.textContent);
      } catch (error) {
        urls = [];
      }

      if (!urls.length) return;

      const cache = new Map();
      let raf = 0;
      let activeSceneId = '';
      let activeFrame = 1;
      let copyTimer = 0;
      let allPreloadStarted = false;

      [1, 32, 72, 103, 104, 116, 127, 151].forEach((frame) => preloadFrame(cache, urls, frame));

      const sceneForProgress = (progress) => {
        return scenes.find((scene) => progress >= scene.from && progress <= scene.to) || scenes[scenes.length - 1];
      };

      const applySceneCopy = (scene) => {
        if (eyebrowEl && eyebrowEl.textContent !== scene.eyebrow) eyebrowEl.textContent = scene.eyebrow;
        if (titleEl && titleEl.textContent !== scene.title) titleEl.textContent = scene.title;
        if (bodyEl && bodyEl.textContent !== scene.body) bodyEl.textContent = scene.body;
        if (metricEl && metricEl.textContent !== scene.metric) metricEl.textContent = scene.metric;
        if (metricNoteEl && metricNoteEl.textContent !== scene.metricNote) metricNoteEl.textContent = scene.metricNote;
        if (backwordEl && backwordEl.textContent !== scene.backword) backwordEl.textContent = scene.backword;
        if (ghostwordEl && ghostwordEl.textContent !== scene.ghostword) ghostwordEl.textContent = scene.ghostword;

        const markerId = scene.marker || scene.id;
        markers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.qdxMarker === markerId);
        });
      };

      const markStableCopy = (scene) => {
        section.classList.toggle('qdx-stable-eyebrow', Boolean(eyebrowEl && eyebrowEl.textContent === scene.eyebrow));
        section.classList.toggle('qdx-stable-title', Boolean(titleEl && titleEl.textContent === scene.title));
        section.classList.toggle('qdx-stable-body', Boolean(bodyEl && bodyEl.textContent === scene.body));
        section.classList.toggle('qdx-stable-metric', Boolean(
          metricEl &&
          metricNoteEl &&
          metricEl.textContent === scene.metric &&
          metricNoteEl.textContent === scene.metricNote
        ));
      };

      const clearStableCopy = () => {
        section.classList.remove('qdx-stable-eyebrow', 'qdx-stable-title', 'qdx-stable-body', 'qdx-stable-metric');
      };

      const setScene = (scene) => {
        if (activeSceneId === scene.id) return;
        const hadScene = Boolean(activeSceneId);
        activeSceneId = scene.id;
        section.dataset.scene = scene.id;
        window.clearTimeout(copyTimer);

        if (!hadScene || reduceMotion) {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
          return;
        }

        markStableCopy(scene);
        section.classList.add('is-changing');
        copyTimer = window.setTimeout(() => {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
        }, 140);
      };

      const frameForProgress = (progress, scene) => {
        if (reduceMotion) return scene.endFrame;
        const local = clamp((progress - scene.from) / Math.max(scene.to - scene.from, 0.0001), 0, 1);
        let eased = local;

        if (scene.easing === 'fast-insert') {
          if (local < 0.58) {
            eased = Math.pow(clamp(local / 0.58, 0, 1), 0.56) * 0.86;
          } else {
            eased = 0.86 + ((local - 0.58) / 0.42) * 0.14;
          }
        }

        if (scene.easing === 'approach-hold') {
          if (local < 0.66) {
            eased = smooth(clamp(local / 0.66, 0, 1));
          } else {
            eased = 1;
          }
        }

        return Math.round(scene.startFrame + (scene.endFrame - scene.startFrame) * eased);
      };

      const sectionProgress = () => {
        if (reduceMotion) return 1;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(rect.height - window.innerHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const swapFrame = (frame) => {
        const index = clamp(frame - 1, 0, urls.length - 1);
        if (frame === activeFrame && imageEl.src === urls[index]) return;

        activeFrame = frame;
        const cached = preloadFrame(cache, urls, frame);
        imageEl.src = cached.src;

        preloadFrame(cache, urls, clamp(frame - 2, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame - 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 2, 1, urls.length));
      };

      const preloadAll = () => {
        if (allPreloadStarted) return;
        allPreloadStarted = true;

        const schedule = window.requestIdleCallback
          ? (callback) => window.requestIdleCallback(callback, { timeout: 700 })
          : (callback) => window.setTimeout(callback, 32);

        const load = (index) => {
          if (index >= urls.length) return;
          preloadFrame(cache, urls, index + 1);
          schedule(() => load(index + 1));
        };

        load(0);
      };

      const render = () => {
        raf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);
        const frame = frameForProgress(progress, scene);

        section.style.setProperty('--qdx-progress', progress.toFixed(4));
        setScene(scene);
        swapFrame(frame);
        if (progress > 0.01) preloadAll();
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      preloadAll();
      requestRender();
    };

    const initBridge = (bridge) => {
      if (bridge.dataset.qdxBridgeReady === 'true') return;
      bridge.dataset.qdxBridgeReady = 'true';

      const setProgress = (progress) => {
        const eased = smooth(clamp(progress, 0, 1));

        bridge.style.setProperty('--qdx-bridge-photo-opacity', (0.34 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-photo-scale', (1.08 - eased * 0.035).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-copy-y', `${(28 - eased * 42).toFixed(2)}px`);
        bridge.style.setProperty('--qdx-bridge-copy-opacity', (0.72 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-line', Math.min(1, eased * 1.06).toFixed(3));
      };

      if (reduceMotion) {
        setProgress(1);
        return;
      }

      let raf = 0;

      const render = () => {
        raf = 0;
        const rect = bridge.getBoundingClientRect();
        const distance = Math.max(rect.height - window.innerHeight, 1);
        const progress = clamp(-rect.top / distance, 0, 1);
        setProgress(progress);
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initReveal = (root) => {
      const items = Array.from(root.querySelectorAll('[data-qdx-reveal]'));
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const initHeaderChrome = (root) => {
      if (!root || document.body.dataset.qdxHeaderReady === 'true') return;
      document.body.dataset.qdxHeaderReady = 'true';
      document.body.classList.add('qdx-cinema-active');

      let lastY = window.scrollY;
      let raf = 0;

      const render = () => {
        raf = 0;
        const y = window.scrollY;
        const rect = root.getBoundingClientRect();
        const inExplorer = rect.bottom > 80 && rect.top < window.innerHeight;
        const scrollingDown = y > lastY + 3;
        const scrollingUp = y < lastY - 10;
        const pastTop = y > 60 && rect.top < 0;

        document.body.classList.toggle('qdx-header-soft', inExplorer && pastTop);

        if (!inExplorer || !pastTop || scrollingUp) {
          document.body.classList.remove('qdx-header-hidden');
        } else if (scrollingDown) {
          document.body.classList.add('qdx-header-hidden');
        }

        lastY = y;
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qdx-scroll]').forEach(initScroll);
      root.querySelectorAll('[data-qdx-bridge]').forEach(initBridge);
      root.querySelectorAll('[data-qdx-root]').forEach(initReveal);
      root.querySelectorAll('[data-qdx-root]').forEach(initHeaderChrome);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-explorer-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const smooth = (value) => value * value * (3 - 2 * value);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const scenes = [
      {
        id: 'hero-start',
        from: 0,
        to: 0.08,
        startFrame: 1,
        endFrame: 31,
        eyebrow: 'QuadDrive Explorer',
        title: 'Build the drive your work actually needs.',
        body: 'A 4-bay USB4 NVMe enclosure for creators, engineers, and mobile workstations that outgrow sealed external SSDs.',
        metric: '4-Bay USB4',
        metricNote: 'QuadDrive enclosure plus 65W USB-C PD adapter. SSDs sold separately.',
        backword: 'QUADDRIVE',
        ghostword: 'USB4'
      },
      {
        id: 'four-nvme',
        from: 0.08,
        to: 0.5,
        startFrame: 32,
        endFrame: 103,
        easing: 'fast-insert',
        eyebrow: 'Install and scale',
        title: 'Start with one NVMe. Scale to four.',
        body: 'Install 2230, 2242, or 2280 M.2 NVMe SSDs and grow toward 32TB total without replacing the enclosure.',
        metric: '1-4 M.2 NVMe',
        metricNote: 'JBOD or OS-managed software RAID workflows.',
        backword: '4 NVME',
        ghostword: '32TB'
      },
      {
        id: 'io-transition',
        marker: 'thunderbolt',
        from: 0.5,
        to: 0.64,
        startFrame: 104,
        endFrame: 127,
        easing: 'approach-hold',
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'The camera moves from the four-bay build to the I/O edge before the speed story lands.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'thunderbolt',
        from: 0.64,
        to: 0.8,
        startFrame: 127,
        endFrame: 127,
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'One USB-C link carries USB4 and Thunderbolt-class data. A separate USB-C PD input feeds stable power to the four-drive system while data moves fast.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'hero-return',
        from: 0.8,
        to: 1,
        startFrame: 128,
        endFrame: 151,
        eyebrow: 'Ready for work',
        title: 'One compact box. A storage plan that keeps growing.',
        body: 'For project media, scratch disks, backup staging, and lab work that needs fast removable NVMe storage without cable clutter.',
        metric: 'Build yours',
        metricNote: 'Order the enclosure, then choose the SSD capacity that fits your workflow.',
        backword: 'READY',
        ghostword: 'SSD'
      }
    ];

    const preloadFrame = (cache, urls, frame) => {
      const index = clamp(frame - 1, 0, urls.length - 1);
      if (cache.has(index)) return cache.get(index);

      const image = new Image();
      image.decoding = 'async';
      image.src = urls[index];
      cache.set(index, image);
      return image;
    };

    const initScroll = (section) => {
      if (section.dataset.qdxReady === 'true') return;
      section.dataset.qdxReady = 'true';

      const frameData = section.querySelector('[data-qdx-frames]');
      const imageEl = section.querySelector('[data-qdx-frame-image]');
      const titleEl = section.querySelector('[data-qdx-title]');
      const bodyEl = section.querySelector('[data-qdx-body]');
      const eyebrowEl = section.querySelector('[data-qdx-eyebrow]');
      const metricEl = section.querySelector('[data-qdx-metric]');
      const metricNoteEl = section.querySelector('[data-qdx-metric-note]');
      const backwordEl = section.querySelector('[data-qdx-backword]');
      const ghostwordEl = section.querySelector('[data-qdx-ghostword]');
      const progressEl = section.querySelector('[data-qdx-progress]');
      const markers = Array.from(section.querySelectorAll('[data-qdx-marker]'));

      if (!frameData || !imageEl) return;

      let urls = [];
      try {
        urls = JSON.parse(frameData.textContent);
      } catch (error) {
        urls = [];
      }

      if (!urls.length) return;

      const cache = new Map();
      let raf = 0;
      let activeSceneId = '';
      let activeFrame = 1;
      let copyTimer = 0;
      let allPreloadStarted = false;

      [1, 32, 72, 103, 104, 116, 127, 151].forEach((frame) => preloadFrame(cache, urls, frame));

      const sceneForProgress = (progress) => {
        return scenes.find((scene) => progress >= scene.from && progress <= scene.to) || scenes[scenes.length - 1];
      };

      const applySceneCopy = (scene) => {
        if (eyebrowEl && eyebrowEl.textContent !== scene.eyebrow) eyebrowEl.textContent = scene.eyebrow;
        if (titleEl && titleEl.textContent !== scene.title) titleEl.textContent = scene.title;
        if (bodyEl && bodyEl.textContent !== scene.body) bodyEl.textContent = scene.body;
        if (metricEl && metricEl.textContent !== scene.metric) metricEl.textContent = scene.metric;
        if (metricNoteEl && metricNoteEl.textContent !== scene.metricNote) metricNoteEl.textContent = scene.metricNote;
        if (backwordEl && backwordEl.textContent !== scene.backword) backwordEl.textContent = scene.backword;
        if (ghostwordEl && ghostwordEl.textContent !== scene.ghostword) ghostwordEl.textContent = scene.ghostword;

        const markerId = scene.marker || scene.id;
        markers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.qdxMarker === markerId);
        });
      };

      const markStableCopy = (scene) => {
        section.classList.toggle('qdx-stable-eyebrow', Boolean(eyebrowEl && eyebrowEl.textContent === scene.eyebrow));
        section.classList.toggle('qdx-stable-title', Boolean(titleEl && titleEl.textContent === scene.title));
        section.classList.toggle('qdx-stable-body', Boolean(bodyEl && bodyEl.textContent === scene.body));
        section.classList.toggle('qdx-stable-metric', Boolean(
          metricEl &&
          metricNoteEl &&
          metricEl.textContent === scene.metric &&
          metricNoteEl.textContent === scene.metricNote
        ));
      };

      const clearStableCopy = () => {
        section.classList.remove('qdx-stable-eyebrow', 'qdx-stable-title', 'qdx-stable-body', 'qdx-stable-metric');
      };

      const setScene = (scene) => {
        if (activeSceneId === scene.id) return;
        const hadScene = Boolean(activeSceneId);
        activeSceneId = scene.id;
        section.dataset.scene = scene.id;
        window.clearTimeout(copyTimer);

        if (!hadScene || reduceMotion) {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
          return;
        }

        markStableCopy(scene);
        section.classList.add('is-changing');
        copyTimer = window.setTimeout(() => {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
        }, 140);
      };

      const frameForProgress = (progress, scene) => {
        if (reduceMotion) return scene.endFrame;
        const local = clamp((progress - scene.from) / Math.max(scene.to - scene.from, 0.0001), 0, 1);
        let eased = local;

        if (scene.easing === 'fast-insert') {
          if (local < 0.58) {
            eased = Math.pow(clamp(local / 0.58, 0, 1), 0.56) * 0.86;
          } else {
            eased = 0.86 + ((local - 0.58) / 0.42) * 0.14;
          }
        }

        if (scene.easing === 'approach-hold') {
          if (local < 0.66) {
            eased = smooth(clamp(local / 0.66, 0, 1));
          } else {
            eased = 1;
          }
        }

        return Math.round(scene.startFrame + (scene.endFrame - scene.startFrame) * eased);
      };

      const sectionProgress = () => {
        if (reduceMotion) return 1;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(rect.height - window.innerHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const swapFrame = (frame) => {
        const index = clamp(frame - 1, 0, urls.length - 1);
        if (frame === activeFrame && imageEl.src === urls[index]) return;

        activeFrame = frame;
        const cached = preloadFrame(cache, urls, frame);
        imageEl.src = cached.src;

        preloadFrame(cache, urls, clamp(frame - 2, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame - 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 2, 1, urls.length));
      };

      const preloadAll = () => {
        if (allPreloadStarted) return;
        allPreloadStarted = true;

        const schedule = window.requestIdleCallback
          ? (callback) => window.requestIdleCallback(callback, { timeout: 700 })
          : (callback) => window.setTimeout(callback, 32);

        const load = (index) => {
          if (index >= urls.length) return;
          preloadFrame(cache, urls, index + 1);
          schedule(() => load(index + 1));
        };

        load(0);
      };

      const render = () => {
        raf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);
        const frame = frameForProgress(progress, scene);

        section.style.setProperty('--qdx-progress', progress.toFixed(4));
        setScene(scene);
        swapFrame(frame);
        if (progress > 0.01) preloadAll();
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      preloadAll();
      requestRender();
    };

    const initBridge = (bridge) => {
      if (bridge.dataset.qdxBridgeReady === 'true') return;
      bridge.dataset.qdxBridgeReady = 'true';

      const setProgress = (progress) => {
        const eased = smooth(clamp(progress, 0, 1));

        bridge.style.setProperty('--qdx-bridge-photo-opacity', (0.34 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-photo-scale', (1.08 - eased * 0.035).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-copy-y', `${(28 - eased * 42).toFixed(2)}px`);
        bridge.style.setProperty('--qdx-bridge-copy-opacity', (0.72 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-line', Math.min(1, eased * 1.06).toFixed(3));
      };

      if (reduceMotion) {
        setProgress(1);
        return;
      }

      let raf = 0;

      const render = () => {
        raf = 0;
        const rect = bridge.getBoundingClientRect();
        const distance = Math.max(rect.height - window.innerHeight, 1);
        const progress = clamp(-rect.top / distance, 0, 1);
        setProgress(progress);
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initReveal = (root) => {
      const items = Array.from(root.querySelectorAll('[data-qdx-reveal]'));
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const initHeaderChrome = (root) => {
      if (!root || document.body.dataset.qdxHeaderReady === 'true') return;
      document.body.dataset.qdxHeaderReady = 'true';
      document.body.classList.add('qdx-cinema-active');

      let lastY = window.scrollY;
      let raf = 0;

      const render = () => {
        raf = 0;
        const y = window.scrollY;
        const rect = root.getBoundingClientRect();
        const inExplorer = rect.bottom > 80 && rect.top < window.innerHeight;
        const scrollingDown = y > lastY + 3;
        const scrollingUp = y < lastY - 10;
        const pastTop = y > 60 && rect.top < 0;

        document.body.classList.toggle('qdx-header-soft', inExplorer && pastTop);

        if (!inExplorer || !pastTop || scrollingUp) {
          document.body.classList.remove('qdx-header-hidden');
        } else if (scrollingDown) {
          document.body.classList.add('qdx-header-hidden');
        }

        lastY = y;
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qdx-scroll]').forEach(initScroll);
      root.querySelectorAll('[data-qdx-bridge]').forEach(initBridge);
      root.querySelectorAll('[data-qdx-root]').forEach(initReveal);
      root.querySelectorAll('[data-qdx-root]').forEach(initHeaderChrome);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-explorer-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const scenes = [
      {
        id: 'hero-start',
        from: 0,
        to: 0.17,
        startFrame: 1,
        endFrame: 31,
        eyebrow: 'QuadDrive',
        title: 'Build your own fast storage.',
        body: 'A compact USB4 enclosure for one to four M.2 NVMe SSDs, built for creators, engineers, and mobile workstations.',
        metric: '4-Bay USB4',
        metricNote: 'Start with the enclosure. Add the SSDs you choose.',
        backword: 'QUADDRIVE',
        ghostword: 'USB4'
      },
      {
        id: 'four-nvme',
        from: 0.17,
        to: 0.68,
        startFrame: 32,
        endFrame: 103,
        eyebrow: 'Frames 032-103',
        title: 'Four NVMe bays. One clean workspace.',
        body: 'Install 1-4 M.2 2230, 2242, or 2280 NVMe SSDs, then scale up to 32TB total when projects grow.',
        metric: '4 x NVMe',
        metricNote: 'Use JBOD or OS-managed software RAID workflows.',
        backword: '4 NVME',
        ghostword: '32TB'
      },
      {
        id: 'thunderbolt',
        from: 0.68,
        to: 0.84,
        startFrame: 127,
        endFrame: 127,
        eyebrow: 'Frame 127',
        title: 'Thunderbolt-ready USB4 I/O.',
        body: 'One USB-C port carries data. One USB-C PD port supplies stable power for multi-drive operation.',
        metric: 'USB4 + PD',
        metricNote: 'Built for USB4 and Thunderbolt 3/4 hosts.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'hero-return',
        from: 0.84,
        to: 1,
        startFrame: 128,
        endFrame: 151,
        eyebrow: 'Frame 151',
        title: 'Compact outside. Expandable inside.',
        body: 'The launch bundle includes QuadDrive enclosure and a 65W USB-C PD adapter. SSDs are sold separately.',
        metric: 'Ready',
        metricNote: 'A palm-size external storage system for serious files.',
        backword: 'READY',
        ghostword: 'SSD'
      }
    ];

    const preloadFrame = (cache, urls, frame) => {
      const index = clamp(frame - 1, 0, urls.length - 1);
      if (cache.has(index)) return cache.get(index);

      const image = new Image();
      image.decoding = 'async';
      image.src = urls[index];
      cache.set(index, image);
      return image;
    };

    const initSection = (section) => {
      if (section.dataset.qdExplorerReady === 'true') return;
      section.dataset.qdExplorerReady = 'true';

      const frameData = section.querySelector('[data-qd-explorer-frames]');
      const imageEl = section.querySelector('[data-qd-frame-image]');
      const titleEl = section.querySelector('[data-qd-title]');
      const bodyEl = section.querySelector('[data-qd-body]');
      const eyebrowEl = section.querySelector('[data-qd-eyebrow]');
      const metricEl = section.querySelector('[data-qd-metric]');
      const metricNoteEl = section.querySelector('[data-qd-metric-note]');
      const backwordEl = section.querySelector('[data-qd-backword]');
      const ghostwordEl = section.querySelector('[data-qd-ghostword]');
      const progressEl = section.querySelector('[data-qd-progress]');
      const markers = Array.from(section.querySelectorAll('[data-qd-scene-marker]'));
      const buyLinks = Array.from(section.querySelectorAll('[data-qd-explorer-buy-link]'));

      if (!frameData || !imageEl) return;

      let urls = [];
      try {
        urls = JSON.parse(frameData.textContent);
      } catch (error) {
        urls = [];
      }

      if (!urls.length) return;

      const cache = new Map();
      let raf = 0;
      let activeSceneId = '';
      let activeFrame = 1;
      let allPreloadStarted = false;

      [1, 32, 103, 127, 151].forEach((frame) => preloadFrame(cache, urls, frame));

      const sceneForProgress = (progress) => {
        return scenes.find((scene) => progress >= scene.from && progress <= scene.to) || scenes[scenes.length - 1];
      };

      const setText = (scene) => {
        if (activeSceneId === scene.id) return;
        activeSceneId = scene.id;
        section.dataset.scene = scene.id;

        if (eyebrowEl) eyebrowEl.textContent = scene.eyebrow;
        if (titleEl) titleEl.textContent = scene.title;
        if (bodyEl) bodyEl.textContent = scene.body;
        if (metricEl) metricEl.textContent = scene.metric;
        if (metricNoteEl) metricNoteEl.textContent = scene.metricNote;
        if (backwordEl) backwordEl.textContent = scene.backword;
        if (ghostwordEl) ghostwordEl.textContent = scene.ghostword;

        markers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.qdSceneMarker === scene.id);
        });
      };

      const frameForProgress = (progress, scene) => {
        if (reduceMotion) return scene.endFrame;
        const local = clamp((progress - scene.from) / Math.max(scene.to - scene.from, 0.0001), 0, 1);
        return Math.round(scene.startFrame + (scene.endFrame - scene.startFrame) * local);
      };

      const sectionProgress = () => {
        if (reduceMotion) return 1;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(rect.height - window.innerHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const swapFrame = (frame) => {
        const index = clamp(frame - 1, 0, urls.length - 1);
        if (frame === activeFrame && imageEl.src === urls[index]) return;

        activeFrame = frame;
        const cached = preloadFrame(cache, urls, frame);
        imageEl.src = cached.src;

        preloadFrame(cache, urls, clamp(frame - 2, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame - 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 2, 1, urls.length));
      };

      const preloadAll = () => {
        if (allPreloadStarted) return;
        allPreloadStarted = true;

        const load = (index) => {
          if (index >= urls.length) return;
          preloadFrame(cache, urls, index + 1);
          const schedule = window.requestIdleCallback || window.setTimeout;
          schedule(() => load(index + 1), { timeout: 700 });
        };

        load(0);
      };

      const render = () => {
        raf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);
        const frame = frameForProgress(progress, scene);

        section.style.setProperty('--qd-explorer-progress', progress.toFixed(4));
        setText(scene);
        swapFrame(frame);
        if (progress > 0.02) preloadAll();
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      buyLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector('product-info[id^="MainProduct"], .product__info-container, form[action*="/cart/add"]');
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      preloadAll();
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qd-explorer-scroll]').forEach(initSection);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-scroll-3d"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const loadModelViewer = () => {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

      window.Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: () => {}
        }
      ]);
    };

    const initRoot = (root) => {
      if (root.dataset.qdScrollReady === 'true') return;
      root.dataset.qdScrollReady = 'true';

      const viewer = root.querySelector('model-viewer');
      const shell = root.querySelector('.qd-scroll-3d__viewer-shell');
      const steps = Array.from(root.querySelectorAll('[data-qd-scroll-step]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let ticking = false;

      const update = () => {
        ticking = false;

        if (reduceMotion) return;

        const rect = root.getBoundingClientRect();
        const range = Math.max(1, rect.height - window.innerHeight);
        const progress = clamp((0 - rect.top) / range, 0, 1);
        const eased = progress * progress * (3 - 2 * progress);

        if (viewer) {
          const orbitX = -38 + eased * 258;
          const orbitY = 64 - Math.sin(eased * Math.PI) * 13;
          const orbitZ = 114 - eased * 17;
          const fov = 34 - eased * 6;

          viewer.setAttribute('camera-orbit', `${orbitX.toFixed(1)}deg ${orbitY.toFixed(1)}deg ${orbitZ.toFixed(1)}%`);
          viewer.setAttribute('field-of-view', `${fov.toFixed(1)}deg`);
        }

        if (shell) {
          shell.style.setProperty('--qd-model-scale', (0.96 + Math.sin(eased * Math.PI) * 0.08).toFixed(3));
        }

        if (steps.length) {
          const activeIndex = clamp(Math.floor(progress * steps.length), 0, steps.length - 1);
          steps.forEach((step, index) => {
            step.classList.toggle('is-active', index === activeIndex);
          });
        }
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      loadModelViewer();
      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
    };

    const init = () => {
      document.querySelectorAll('[data-qd-scroll-3d]').forEach(initRoot);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-scroll-rendered"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initSection = (section) => {
      if (section.dataset.qdRenderedReady === 'true') return;
      section.dataset.qdRenderedReady = 'true';

      const video = section.querySelector('[data-qd-render-video]');
      const steps = Array.from(section.querySelectorAll('[data-qd-render-step]'));
      const meter = section.querySelector('[data-qd-render-meter]');
      if (!video) return;

      let raf = 0;
      let duration = 0;

      const activateStep = (progress) => {
        if (!steps.length) return;
        const index = clamp(Math.floor(progress * steps.length), 0, steps.length - 1);
        steps.forEach((step, stepIndex) => {
          step.classList.toggle('is-active', stepIndex === index);
        });
      };

      const readProgress = () => {
        if (reduceMotion) return 0;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(rect.height - window.innerHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const render = () => {
        raf = 0;
        const progress = readProgress();
        section.style.setProperty('--qd-render-progress', progress.toFixed(4));
        if (meter) meter.style.transform = 'translateZ(0)';
        activateStep(progress);

        if (duration > 0 && !reduceMotion) {
          const targetTime = clamp(progress * duration, 0, duration - 0.02);
          if (Math.abs(video.currentTime - targetTime) > 0.035) {
            video.currentTime = targetTime;
          }
        }
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      const onReady = () => {
        duration = video.duration || 0;
        video.pause();
        requestRender();
      };

      video.addEventListener('loadedmetadata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qd-render-scroll]').forEach(initSection);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v10"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__copy',
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const start = window.innerHeight * 0.72;
            const end = -rect.height + window.innerHeight * 0.34;
            const progress = reduceMotion ? 1 : clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
            const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v11"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__copy',
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const start = window.innerHeight * 0.72;
            const end = -rect.height + window.innerHeight * 0.34;
            const progress = reduceMotion ? 1 : clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
            const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v12"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const travel = Math.max(rect.height - window.innerHeight, 1);
            const progress = reduceMotion ? 1 : clamp(-rect.top / travel, 0, 1);
            const playbackProgress = reduceMotion ? 1 : clamp((progress - 0.05) / 0.86, 0, 1);
            const eased =
              playbackProgress < 0.5
                ? 2 * playbackProgress * playbackProgress
                : 1 - Math.pow(-2 * playbackProgress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v13"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const travel = Math.max(rect.height - window.innerHeight, 1);
            const scrollProgress = reduceMotion ? 1 : clamp(-rect.top / travel, 0, 1);
            const entryProgress = reduceMotion
              ? 1
              : clamp((window.innerHeight - rect.top) / (window.innerHeight * 0.5), 0, 1);
            const playbackProgress = reduceMotion ? 1 : clamp((scrollProgress - 0.08) / 0.88, 0, 1);
            const eased = playbackProgress;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', playbackProgress.toFixed(4));
            buildSection.style.setProperty('--qds-build-float', entryProgress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (entryProgress > 0.35) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v14"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const payLaterMessage = root.querySelector('[data-paypal-pay-later-message]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;
        if (payLaterMessage && variant.price_amount) {
          payLaterMessage.setAttribute('data-pp-amount', variant.price_amount);
        }

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-fit__negative',
            '.qds-fit__actions',
            '.qds-ssd-guide__head',
            '.qds-ssd-guide__grid article',
            '.qds-ssd-guide__note',
            '.qds-box__media',
            '.qds-included__copy',
            '.qds-box__grid li',
            '.qds-box__badges span',
            '.qds-box__notice',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const travel = Math.max(rect.height - window.innerHeight, 1);
            const scrollProgress = reduceMotion ? 1 : clamp(-rect.top / travel, 0, 1);
            const entryProgress = reduceMotion
              ? 1
              : clamp((window.innerHeight - rect.top) / (window.innerHeight * 0.5), 0, 1);
            const playbackProgress = reduceMotion ? 1 : clamp((scrollProgress - 0.08) / 0.88, 0, 1);
            const eased = playbackProgress;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', playbackProgress.toFixed(4));
            buildSection.style.setProperty('--qds-build-float', entryProgress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (entryProgress > 0.35) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v6"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v7"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v8-legacy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v8"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__copy',
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const start = window.innerHeight * 0.72;
            const end = -rect.height + window.innerHeight * 0.34;
            const progress = reduceMotion ? 1 : clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
            const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v9"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__copy',
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const start = window.innerHeight * 0.72;
            const end = -rect.height + window.innerHeight * 0.34;
            const progress = reduceMotion ? 1 : clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
            const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raiden-home-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-rdv-home]');
    if (!roots.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach((root) => {
      const carousel = root.querySelector('[data-rdv-carousel]');
      const slides = Array.from(root.querySelectorAll('[data-rdv-slide]'));
      const controls = Array.from(root.querySelectorAll('[data-rdv-slide-control]'));
      const progress = Array.from(root.querySelectorAll('[data-rdv-progress]'));
      const slideDuration = carousel ? Number.parseInt(carousel.dataset.rdvSlideDuration || '7000', 10) : 7000;
      let activeIndex = 0;
      let timer = null;

      const setSlide = (nextIndex) => {
        if (!slides.length) return;
        activeIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        controls.forEach((control, index) => {
          const isActive = index === activeIndex;
          control.classList.toggle('is-active', isActive);
          control.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        progress.forEach((bar, index) => {
          bar.classList.remove('is-active');
          if (index === activeIndex) {
            void bar.offsetWidth;
            bar.classList.add('is-active');
          }
        });
      };

      const scheduleNext = () => {
        if (reduceMotion || slides.length < 2) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
          setSlide(activeIndex + 1);
          scheduleNext();
        }, slideDuration);
      };

      controls.forEach((control, index) => {
        control.addEventListener('click', () => {
          setSlide(index);
          scheduleNext();
        });
      });

      setSlide(0);
      scheduleNext();

      document.addEventListener('visibilitychange', () => {
        window.clearTimeout(timer);
        if (!document.hidden) {
          scheduleNext();
        }
      });

      const revealTargets = Array.from(root.querySelectorAll('.rdv-reveal'));
      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
      );

      revealTargets.forEach((target) => observer.observe(target));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raiden-shop-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-rda-shop-offer]').forEach((offer) => {
      const close = offer.querySelector('[data-rda-shop-offer-close]');
      if (!close) return;

      close.addEventListener('click', () => {
        offer.classList.add('is-hidden');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raiden-static-page-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-rdv-static]');
    if (!roots.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach((root) => {
      const targets = Array.from(root.querySelectorAll('.rdv-static-reveal'));
      if (reduceMotion || !('IntersectionObserver' in window)) {
        targets.forEach((target) => target.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
      );

      targets.forEach((target) => observer.observe(target));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
